import React from 'react'
import clsx from 'clsx'
import { icons } from './svg'

export default ({ url, width, height, style, fill, className }) => {
  // protocol : lsvg 本地 svg
  //            rsvg 远程 svg
  //            limg 本地 图片
  //            rimg 远程 图片
  const [protocol, path] = (url || '').split('://')

  if (protocol === 'lsvg') {
    const icon = icons[path]
    if (!icon) {
      return null
    }
    return (
      <svg
        width={width || icon.width}
        height={height || icon.height}
        viewBox={icon.viewBox}
        fill={fill || icon.fill}
        className={clsx([className, 'inline-block'])}
        style={{
          flexShrink: 0,
          shapeRendering: 'geometricPrecision',
          transform:
            `scale(0.8) ${style && style.isOpen ? 'rotate(90deg)' : ''}` ||
            'unset',
          color: `${!fill && !className ? icon.fill : fill}`,
          marginRight: `${style ? style.marginRight : ''}`,
          transition: `all 350ms ease`,
        }}
      >
        {icon.d.map((d) => (
          <path
            key={d}
            fillRule="evenodd"
            d={d}
            fill={fill || 'currentColor'}
            stroke="currentColor"
            strokeWidth={icon.strokeWidth || 0.8}
          />
        ))}
      </svg>
    )
  }
  return null
}
